export const cashbackUrl = 'cashback';
